import styled from "styled-components";
import { RegisterWrapper, RegisterDisplayer } from "../Register/Styles";

export const LoginWrapper = styled(RegisterWrapper)`
  background-color: #001d30;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100vh;
  height: auto;
  padding-top: 2rem;
  padding-bottom: 2rem;

  > img {
    z-index: 10;
    position: relative;
    width: auto;
    height: 3rem;
    margin-bottom: 1rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;

    > img {
      height: 2.5rem;
      margin-bottom: 0.75rem;
    }
  }
`;

export const LoginDisplayer = styled(RegisterDisplayer)`
  background-color: #fff !important;
  z-index: 10;
  position: relative;
  max-width: 520px;
  width: 100%;
  padding: 2.5rem;
  border-radius: 1rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border: 1px solid #F2F3F7;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 90%;
    padding: 1.5rem;
    margin-bottom: 0.5rem;
    max-width: calc(100% - 1rem);
    margin-left: auto;
    margin-right: auto;
  }
`;

export const LoginFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  min-height: auto;
  width: 100%;
  gap: ${(props) => props.theme.spacing.medium};
  padding: ${(props) => props.theme.spacing.medium};

  button {
    width: 100%;
  }

  button:not(.nextstep) {
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.font.primary};
    border: 1px solid ${(props) => props.theme.colors.border};
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: ${(props) => props.theme.spacing.small};
    gap: ${(props) => props.theme.spacing.small};
  }
`;

export const RegisterLink = styled.b`
  color: #34d399;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    color: #10b981;
    text-decoration: underline;
  }
`;

export const LoginButton = styled.button<{ $isLoading?: boolean }>`
  background-color: #021526 !important;
  color: ${(props) => (props.$isLoading ? "transparent" : "white")} !important;
  font-weight: 600;
  padding: 0.875rem 1rem !important;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  border: none;
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSizes.small};
  position: relative;

  &:hover:not(:disabled) {
    background-color: #032940 !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.8;
    cursor: not-allowed;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
    transition: transform 0.2s;
  }

  &:hover:not(:disabled) svg {
    transform: translateX(2px);
  }
`;

export const FormSeparator = styled.span`
  text-align: center;
  font-weight: 600;
  color: #989898;
`;

export const NavigateParagraph = styled.span`
  font-size: ${(p) => p.theme.fontSizes.small};
  font-weight: 300;
  text-align: center;
  > b {
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const SecondaryButton = styled.button`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.font.primary};
  border: 1px solid ${(props) => props.theme.colors.border};
  font-weight: 500;
  padding: 0.875rem 1rem;
  border-radius: 0.5rem;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  cursor: pointer;
  font-size: ${(props) => props.theme.fontSizes.small};

  &:hover:not(:disabled) {
    background-color: ${(props) => props.theme.colors.border};
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const AnimatedBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;

  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }

  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    mix-blend-mode: overlay;
    opacity: 0.1;
    animation: blob 7s infinite;
  }

  .blob-1 {
    top: 0;
    left: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #3b82f6;
    animation-delay: 0s;
  }

  .blob-2 {
    top: 0;
    right: 25%;
    width: 24rem;
    height: 24rem;
    background-color: #a855f7;
    animation-delay: 2s;
  }

  .blob-3 {
    bottom: -8rem;
    left: 33%;
    width: 24rem;
    height: 24rem;
    background-color: #34d399;
    animation-delay: 4s;
  }
`;
